"use client";

import { useParams } from "next/navigation";
import { TabSetSearchParam } from "../tab";
import { YEARLYSchedule as Y } from "@/constants/constant-client";

export function MonthTab() {
  const { year } = useParams();
  const ALLYear = ["2025", "2024", "2023", "2022"] as const;
  const yearComp = ALLYear.find((f) => f === year) || ALLYear[0];

  const afterLastDay = new Date(Y?.[yearComp]?.pennant?.end) < new Date();
  const nullToParam = afterLastDay ? "10" : String(new Date().getMonth() + 1);

  return (
    <div role="tablist" className="tabs tabs-border min-w-36">
      {["3", "4", "5", "6", "7", "8", "9", "10", "ALL"].map((m) => {
        return (
          <TabSetSearchParam
            key={m}
            paramName="month"
            param={m === nullToParam ? null : m}
            delParamName={m === nullToParam ? "month" : undefined}
          >
            {m}
          </TabSetSearchParam>
        );
      })}
    </div>
  );
}
